import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDBadgeDot from 'components/MDBadgeDot';
import { PieChart } from '@mui/x-charts/PieChart';

function ChannelsChart({ projects }) {
    const [uniqueCustomerNumber, setUniqueCustomerNumber] = useState(0);
    const [pieChartData, setPieChartData] = useState([]);
    const [colors, setColors] = useState([]);

    useEffect(() => {
        const customerDistribution = projects.reduce((acc, cur) => {
            const customerName = cur.aaroCustomerName;
            acc[customerName] = (acc[customerName] || 0) + 1;
            return acc;
        }, {});
        setUniqueCustomerNumber(Object.entries(customerDistribution).length);
        const sortedDistribution = Object.entries(customerDistribution)
            .sort((a, b) => b[1] - a[1]) // Sort by the number of projects in descending order
            .slice(0, 5); // Take only the top 5

        const colorMap = {
            info: '#1A73E8',
            primary: '#7928CA',
            dark: '#344767',
            secondary: '#8392AB',
            success: '#4CAF50',
            error: '#F44335',
        };

        const colorNames = ['info', 'primary', 'dark', 'secondary', 'success', 'error'];

        const chartData = sortedDistribution.map(([name, value], index) => ({
            id: index,
            value,
            label: name.substring(0, 15),
            color: colorMap[colorNames[index % colorNames.length]],
        }));

        setPieChartData(chartData);
        setColors(chartData.map((item) => item.color));
    }, [projects]);

    return (
        <Card sx={{ height: '100%' }}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
                <MDTypography variant="h6">En Çok Teklif Verilen 5 Müşteri</MDTypography>
            </MDBox>
            <MDBox mt={3}>
                <Grid
                    container
                    sx={{
                        alignItems: 'center',
                    }}
                >
                    <Grid size={12}>
                        <MDBox height="12.5rem">
                            <PieChart
                                series={[
                                    {
                                        data: pieChartData,
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        innerRadius: 30,
                                        paddingAngle: 2,
                                        cornerRadius: 4,
                                    },
                                ]}
                                colors={colors}
                                slotProps={{
                                    legend: { hidden: true },
                                }}
                                height={200}
                                margin={{ right: 5 }}
                            />
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <MDBox pt={4} pb={2} px={2} display="flex" flexDirection={{ xs: 'column', sm: 'row' }} mt="auto">
                <MDTypography variant="caption">
                    Aktif ve pasif bütün projeler üzerinden hesaplanmaktadır. Toplam teklif verdiğiniz müşteri sayısı:{' '}
                    {uniqueCustomerNumber}{' '}
                </MDTypography>
            </MDBox>
        </Card>
    );
}

export default ChannelsChart;
